import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d051c3de"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-plus" }, null, -1));
const _hoisted_5 = { key: 2 };
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import AudienceConditionCardGroup from '@/features/AudienceManager/components/Stages/Composition/AudienceConditionCardGroup.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceCompositionStage',
    props: {
        isInclude: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { isCreationMode, groupType, conditionsByGroupType } = useAudienceManager(props.isInclude);
        const hasNoAudienceData = computed(() => store.getters['audienceManager/hasNoAudienceData']);
        const query = computed(() => store.getters['audienceManager/query']);
        const shouldShowEmptyGroupMessage = computed(() => {
            if (isCreationMode.value)
                return false;
            const groupConditions = query.value[groupType.value];
            return Array.isArray(groupConditions) && groupConditions.length === 0;
        });
        const addNewGroup = () => {
            store.dispatch('audienceManager/addGroup', { isInclude: props.isInclude });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("section", {
                    id: `audience-${_unref(groupType)}`,
                    class: "composition-stage"
                }, [
                    (!hasNoAudienceData.value)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$t(`audiences.${_unref(groupType)}`)), 1))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionsByGroupType), (groupConditions, index) => {
                        return (_openBlock(), _createBlock(AudienceConditionCardGroup, {
                            key: `${_unref(groupType)}-${index}`,
                            "group-index": index,
                            "is-include": props.isInclude,
                            "group-conditions": groupConditions
                        }, null, 8, ["group-index", "is-include", "group-conditions"]));
                    }), 128)),
                    (_unref(isCreationMode))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _withModifiers(addNewGroup, ["prevent"]),
                            class: "composition-stage__add-group"
                        }, [
                            _hoisted_4,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`audiences.add-group-${_unref(groupType)}`)), 1)
                        ], 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    (shouldShowEmptyGroupMessage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t(`audiences.no-${_unref(groupType)}`)), 1))
                        : _createCommentVNode("", true)
                ], 8, _hoisted_1)
            ]));
        };
    }
});
